import MemberListPage from './Component/MemberListPage';
import memberRoleConfig from './memberRoleConfig';

const TenantsPage = () => <MemberListPage roleConfig={memberRoleConfig.tenant} />;

export default TenantsPage;
